module.exports = __webpack_public_path__ + "static/media/TipBulb.a80dbf97.svg";